DJ.addBehavior('video-cover', '.video-cover', {
  attach: function(context, settings, behavior) {

    jQuery(this).click(function () {
      var iframe = jQuery(this).closest('.post-block__video').find('iframe');
      var videoSrc = iframe.attr('src');
      iframe.attr('src', `${videoSrc}&autoplay=1`).css('display','block');
      jQuery(this).closest('.post-block__video').addClass('active');
    });

  },

  detach: function(context, settings) {}
});
